import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { toggleModalMemberRemove } from '../../../redux/main/main.actions';
import { selectIsModalMemberRemoveEnabled, selectModalMemberRemoveData } from '../../../redux/main/main.selectors';
import { selectCurrentWorkspace } from '../../../redux/workspace/workspace.selectors';
import { workspaceRemoveMemberRequest } from '../../../redux/workspace/workspace.actions';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalMemberRemove.scss';

export const ModalMemberRemove = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalMemberRemoveEnabled);
    const modalData = useSelector(selectModalMemberRemoveData);
    const workspace = useSelector(selectCurrentWorkspace);

    const [member, setMember] = useState(null);
    const [label, setLabel] = useState('');

    useEffect(() => {
        setMember(modalData?.member || null);

        const next = modalData?.member?.name || modalData?.member?.email;
        if (!next) return;

        if (label !== next) {
            setLabel(next);
        }

        return () => { };
    }, [modalData]);

    const reset = () => {
        setMember(null);
        setLabel('');
    };

    const handleCancel = () => {
        dispatch(toggleModalMemberRemove(null));
        setTimeout(reset, 300);
    };

    const handleRemove = () => {
        // The remove endpoint keys off the target's users.id (see
        // members-management-frontend-integration.md §4), not the membership row id.
        const userId = member?.user_id;
        if (!userId || !workspace?.id) return;
        trackEvent('app_modal_member_remove_submit', {
            page: 'app',
            type: 'modals',
        });
        dispatch(workspaceRemoveMemberRequest({ workspaceId: workspace.id, userId }));
        dispatch(toggleModalMemberRemove(null));
        setTimeout(reset, 300);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass="modal-member-remove"
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t('m_member_remove.header')}</div>
            <div className="modal-content-body">
                <div className="description-text">
                    {t('m_member_remove.desc_prefix')}<span className="text-title-bold">{label}</span> {t('m_member_remove.desc_suffix')}
                </div>
                <div className="buttons-wrap">
                    <button className="button-second" onClick={handleCancel}>{t('b.cancel')}</button>
                    <button className="" onClick={handleRemove}>{t('b.remove')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalMemberRemove;
